import React from 'react';

const LockKeyholeOpenIcon = (props) => {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" width={props.width ? props.width : '24'}
             height={props.height ? props.height : '24'} viewBox="0 0 24 24" fill="none"
             stroke={props.stroke ? props.stroke : 'currentColor'}
             strokeWidth={props.strokeWidth ? props.strokeWidth : '2'} strokeLinecap="round"
             strokeLinejoin="round"
        >
            <circle cx="12" cy="16" r="1"/>
            <rect width="18" height="12" x="3" y="10" rx="2"/>
            <path d="M7 10V7a5 5 0 0 1 9.33-2.5"/>
        </svg>
    );
};

export default LockKeyholeOpenIcon;


// WEBPACK FOOTER //
// ./src/assets/icons/LockKeyholeOpenIcon.jsx